import { Badge } from "@/components/ui/badge";
import { CONV_STATE, LEAD_STATUS, PROP_STATUS } from "@/lib/api";

const CONV_CLS = {
  AI_ACTIVE: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/60 dark:text-emerald-300",
  WAITING_HUMAN: "bg-amber-100 text-amber-800 dark:bg-amber-950/60 dark:text-amber-300",
  HUMAN_ACTIVE: "bg-blue-100 text-blue-800 dark:bg-blue-950/60 dark:text-blue-300",
  CLOSED: "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300",
};
const PROP_CLS = {
  disponivel: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/60 dark:text-emerald-300",
  reservado: "bg-amber-100 text-amber-800 dark:bg-amber-950/60 dark:text-amber-300",
  vendido: "bg-gray-200 text-gray-700 dark:bg-gray-800 dark:text-gray-300",
  alugado: "bg-blue-100 text-blue-800 dark:bg-blue-950/60 dark:text-blue-300",
  inativo: "bg-red-100 text-red-700 dark:bg-red-950/50 dark:text-red-300",
};

const base = "border-0 font-semibold uppercase tracking-wider text-[10px] px-2 py-0.5 rounded-md shadow-none";

export const StateBadge = ({ state, testid }) => (
  <Badge data-testid={testid || `state-badge-${state}`} className={`${base} ${CONV_CLS[state] || ""}`}>{CONV_STATE[state] || state}</Badge>
);

export const PropStatusBadge = ({ status }) => (
  <Badge data-testid={`prop-status-${status}`} className={`${base} ${PROP_CLS[status] || ""}`}>{PROP_STATUS[status] || status}</Badge>
);

export const LeadStatusBadge = ({ status }) => (
  <Badge data-testid={`lead-status-${status}`} className={`${base} bg-secondary text-secondary-foreground`}>{LEAD_STATUS[status] || status}</Badge>
);

export const ScorePill = ({ score }) => {
  const cls = score >= 60 ? "bg-accent text-accent-foreground" : score >= 30 ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/60 dark:text-emerald-300" : "bg-muted text-muted-foreground";
  return <span data-testid="lead-score" className={`font-mono text-xs px-2 py-0.5 rounded-md ${cls}`}>{score ?? 0}</span>;
};

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
    <div>
      <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
      {subtitle && <p className="text-muted-foreground mt-2 text-sm md:text-base">{subtitle}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const Sel = ({ value, onChange, options, testid, placeholder, className = "" }) => (
  <select data-testid={testid} value={value ?? ""} onChange={(e) => onChange(e.target.value)}
    className={`h-9 rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring ${className}`}>
    {placeholder !== undefined && <option value="">{placeholder}</option>}
    {Object.entries(options).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
  </select>
);

export const Field = ({ label, children, className = "" }) => (
  <label className={`block space-y-1.5 ${className}`}><span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</span>{children}</label>
);

export const Empty = ({ text }) => <div className="text-center text-muted-foreground text-sm py-12 border border-dashed rounded-xl">{text}</div>;
